export const commandVersion1_2_0 = '1.2.0';
export const commandVersion1_3_0 = '1.3.0';
export const commandVersion1_5_0 = '1.5.0';

export const isVersionLessThan = (current: string, target: string): boolean => {
  const currentParts = current.split('.').map(Number);
  const targetParts = target.split('.').map(Number);

  for (let i = 0; i < targetParts.length; i++) {
    if ((currentParts[i] || 0) < targetParts[i]) return true;
    if ((currentParts[i] || 0) > targetParts[i]) return false;
  }
  return false;
};
